export const DOMO_ACCESS_TOKEN_API = '/domo/access-token';
export const DOMO_FETCH_DATASETS = '/domo/datasets';
export const DOMO_DATASET_UPLOAD = '/domo/upload';
export const DOMO_DATASET_CREATE = '/domo/dataset/create';
export const DOMO_DATASET_EXPORT = '/domo/export';
export const DOMO_VALIDATE_API = '/domo/account';
export const SUCCESS = 'success';
export const FAILURE = 'failure';
